import React from 'react';
import PropTypes from 'prop-types';
import { FormattedTime, injectIntl, defineMessages } from 'react-intl';
import find from 'lodash.find';

import TwoStepsDownloadButton from '../../misc/TwoStepsDownloadButton';
import { FormattedMessageWrappedInSpan } from '../../misc';

const ThumbnailPreviewAccountDetails = props => {
  const {
    photoSgId,
    photoNodeId,
    shotDate,
    originalUrl,
    socialMediaUrl,
    startNumbers,
    pendingRequests,
    canRestartUpload,
    uploadRestarted,
    intl,
    onRequestHighResolutionPhoto,
    onDownloadCertificate,
  } = props;

  return (
    <div className="thumbnail-preview-details">
      <div className="row">
        <div className="col-xs-16 col-sm-6">
          <div className="thumbnail-preview-photo-number">
            <span>{photoSgId}</span>
          </div>
          {shotDate && (
            <div className="thumbnail-preview-time">
              <FormattedTime value={new Date(shotDate)} />
            </div>
          )}
        </div>
        <div className="thumbnail-preview-account-event-actions col-xs-16 col-sm-10">
          {originalUrl && (
            <a href={originalUrl} download>
              <button className="primary">
                <FormattedMessageWrappedInSpan
                  id="thumbnailPreviewAccountDetails.actions.downloadHighResolution"
                  defaultMessage="Download high resolution"
                />
              </button>
            </a>
          )}
          {!originalUrl &&
            canRestartUpload &&
            !uploadRestarted && (
              <button className="secondary" onClick={onRequestHighResolutionPhoto}>
                <FormattedMessageWrappedInSpan
                  id="thumbnailPreviewAccountDetails.actions.requestHighResolution"
                  defaultMessage="Request high resolution"
                />
              </button>
            )}
          {socialMediaUrl && (
            <a href={socialMediaUrl} download>
              <button className="primary">
                <FormattedMessageWrappedInSpan
                  id="thumbnailPreviewAccountDetails.actions.downloadSocialMediaResolution"
                  defaultMessage="Download Social Media Resolution"
                />
              </button>
            </a>
          )}
          {originalUrl &&
            startNumbers &&
            startNumbers.map(sn => {
              const pendingRequest = find(
                pendingRequests,
                r => r.id === photoNodeId && r.startNumber === sn,
              );

              return (
                <TwoStepsDownloadButton
                  key={sn}
                  requestLabel={intl.formatMessage(
                    translations.downloadCertificateButton,
                    {
                      startNumber: sn,
                    },
                  )}
                  isPending={Boolean(pendingRequest)}
                  onRequest={() => onDownloadCertificate(photoNodeId, sn)}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
};

const translations = defineMessages({
  generateCertificateButton: {
    id: 'thumbnailPreviewAccountDetails.actions.generateCertificate',
    defaultMessage: 'Generate certificate for No. {startNumber}',
  },
  downloadCertificateButton: {
    id: 'thumbnailPreviewAccountDetails.actions.downloadCertificate',
    defaultMessage: 'Download certificate for No. {startNumber}',
  },
});

ThumbnailPreviewAccountDetails.propTypes = {
  photoSgId: PropTypes.number,
  photoNodeId: PropTypes.string,
  shotDate: PropTypes.string,
  socialMediaUrl: PropTypes.string,
  originalUrl: PropTypes.string,
  canRestartUpload: PropTypes.bool,
  uploadRestarted: PropTypes.bool,
  startNumbers: PropTypes.array,
  pendingRequests: PropTypes.array,
  intl: PropTypes.object,
  onRequestHighResolutionPhoto: PropTypes.func,
  onDownloadCertificate: PropTypes.func,
};

export default injectIntl(ThumbnailPreviewAccountDetails);
export { ThumbnailPreviewAccountDetails };
